import React, { useEffect, useRef } from 'react';

const DISMISS_MS = 5 * 60 * 1000; // 5 minutes

function SingleNotification({ notif, onDismiss, onClick }) {
    const timerRef = useRef(null);

    useEffect(() => {
        timerRef.current = setTimeout(() => onDismiss(notif.id), DISMISS_MS);
        return () => clearTimeout(timerRef.current);
    }, [notif.id, onDismiss]);

    const preview = notif.content
        ? notif.content.length > 80 ? notif.content.slice(0, 80) + '…' : notif.content
        : notif.hasFile ? '📎 Sent a file' : '';

    return (
        <div
            style={{
                background: '#1e293b',
                border: '1px solid #334155',
                borderLeft: '4px solid #6366f1',
                borderRadius: '10px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.45)',
                padding: '14px 16px',
                width: '320px',
                cursor: 'pointer',
                position: 'relative',
                animation: 'slideInRight 0.25s ease-out',
            }}
            onClick={() => onClick(notif)}
        >
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{
                        width: '28px', height: '28px', borderRadius: '50%',
                        background: 'linear-gradient(135deg, #6366f1, #818cf8)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '11px', fontWeight: '700', color: '#fff', flexShrink: 0,
                    }}>
                        {notif.senderInitials}
                    </div>
                    <div>
                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#f1f5f9' }}>
                            {notif.senderDisplay}
                        </div>
                        {notif.groupName && (
                            <div style={{ fontSize: '10px', color: '#94a3b8' }}>in {notif.groupName}</div>
                        )}
                    </div>
                </div>
                <button
                    onClick={(e) => { e.stopPropagation(); onDismiss(notif.id); }}
                    style={{
                        background: 'transparent', border: 'none', color: '#64748b',
                        cursor: 'pointer', fontSize: '16px', lineHeight: 1, padding: '2px 4px',
                        borderRadius: '4px',
                    }}
                    title="Dismiss"
                >
                    ✕
                </button>
            </div>

            {/* Message preview */}
            <div style={{ fontSize: '13px', color: '#cbd5e1', lineHeight: 1.4, paddingLeft: '36px' }}>
                {preview}
            </div>

            {/* Click hint */}
            <div style={{ fontSize: '10px', color: '#475569', marginTop: '8px', paddingLeft: '36px' }}>
                Click to open chat
            </div>
        </div>
    );
}

export default function ChatNotificationPopup({ notifications, onDismiss, onOpen }) {
    if (!notifications || notifications.length === 0) return null;

    return (
        <>
            <style>{`
                @keyframes slideInRight {
                    from { transform: translateX(120%); opacity: 0; }
                    to   { transform: translateX(0);    opacity: 1; }
                }
            `}</style>
            <div style={{
                position: 'fixed',
                bottom: '24px',
                right: '24px',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column-reverse',
                gap: '10px',
                pointerEvents: 'none',
            }}>
                {notifications.map(notif => (
                    <div key={notif.id} style={{ pointerEvents: 'all' }}>
                        <SingleNotification
                            notif={notif}
                            onDismiss={onDismiss}
                            onClick={onOpen}
                        />
                    </div>
                ))}
            </div>
        </>
    );
}
